import { PlusIcon } from '@phosphor-icons/react'
import { Button } from 'app/components/ui/button'
import { cn } from 'app/lib/utils'
import { useWorkflowActions } from '../WorkflowActions'
import { MoveHereButton } from '../MoveHereButton'

type AppendButtonProps = {
  nodeId: string
  sourceHandle?: string | null
  className?: string
  style?: React.CSSProperties
}

/** "+" shown at an open output to append the next step. Opens the block picker. While a step is
 *  being moved it becomes a drop target instead. */
export function AppendButton({ nodeId, sourceHandle, className, style }: AppendButtonProps) {
  const { appendFromNode, moving, dropMove } = useWorkflowActions()
  if (moving) {
    if (moving.travelling.has(nodeId)) return null
    return (
      <MoveHereButton
        style={style}
        className={cn(`absolute z-10`, className)}
        onClick={() => dropMove({ kind: `end`, source: nodeId, sourceHandle: sourceHandle ?? null })}
      />
    )
  }
  return (
    <Button
      variant="white"
      shape="pill"
      title="Add next step"
      aria-label="Add next step"
      style={style}
      onClick={(e) => {
        e.stopPropagation()
        appendFromNode({ nodeId, sourceHandle, screen: { x: e.clientX, y: e.clientY } })
      }}
      className={cn(
        `nodrag nopan absolute z-10 size-5 border-strong p-0 text-subtle shadow-sm hover:border-(--fg-subtle) hover:bg-surface hover:text-default`,
        className,
      )}
    >
      <PlusIcon size={11} weight="bold" />
    </Button>
  )
}
